module.exports = {"id":"223848","name":"Sergej Milinković-Savić","rating":"83","photo":"./data/images/photos/1/223848.png","club":{"name":"Lazio Rome","logo":"./data/images/clubs/LazioRome.png"},"positions":["MC","MOC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SergejMilinkovic-Savic0.json
// module id = 3900
// module chunks = 0